export default __webpack_public_path__ + "static/media/uk.0d8a3e4e.png";